import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost' | 'destructive';
type Size = 'sm' | 'md';

const VARIANT_STYLES: Record<Variant, string> = {
  primary: 'bg-accent text-on-accent hover:bg-accent-hover active:scale-[0.98]',
  secondary:
    'bg-accent-faint text-text border border-border hover:bg-[rgba(0,0,0,0.07)]',
  ghost: 'text-muted hover:bg-accent-faint hover:text-text',
  destructive:
    'bg-error-bg text-badge-error-text border border-[rgba(255,92,92,0.2)] hover:bg-[rgba(255,92,92,0.16)]',
};
const SIZE_STYLES: Record<Size, string> = {
  sm: 'px-3 py-1.5 text-xs gap-1.5',
  md: 'px-3.5 py-2 text-[13px] gap-2',
};

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  loading?: boolean;
  children: ReactNode;
}

export function Button({
  variant = 'primary',
  size = 'md',
  loading,
  children,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  return (
    <button
      {...props}
      disabled={disabled || loading}
      className={[
        'inline-flex items-center justify-center rounded-lg font-medium transition-all duration-100 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed',
        VARIANT_STYLES[variant],
        SIZE_STYLES[size],
        className,
      ].join(' ')}
    >
      {loading && (
        <span className="w-3.5 h-3.5 border-2 border-current border-t-transparent rounded-full animate-spin-slow shrink-0" />
      )}
      {children}
    </button>
  );
}
